/* CO36 — 6 Reasons landing page (POLO)
   Companion to sections/co36-polo.liquid. Contains no Liquid.

   The page works with JavaScript disabled: swatches, sizes and the first
   product gallery are printed server side. This file only handles selection,
   the gallery swap, the size finder and add to cart. */
(function () {
  "use strict";

  function attr(el, name, fallback) {
    var v = el.getAttribute(name);
    return v === null || v === "" ? fallback : v;
  }

  function json(el, name, fallback) {
    try {
      var v = JSON.parse(attr(el, name, ""));
      return v || fallback;
    } catch (e) {
      return fallback;
    }
  }


  /* Every Polo Shirt variant ID, by color name then size. Used whenever a Color
     block has no IDs of its own, so add to cart works with zero setup. */
  var FALLBACK_IDS = {
    "black":   { XS:"43665842765981", S:"43665842962589", M:"43665843159197", L:"43665843355805", XL:"43665843552413", XXL:"43665843749021" },
    "white":   { XS:"43700823294109", S:"43700823425181", M:"43700823556253", L:"43700823687325", XL:"43700823818397", XXL:"43700823982237" },
    "navy":    { XS:"45455712026781", S:"45455712092317", M:"45455712157853", L:"45455712223389", XL:"45455712288925", XXL:"45455712354461" },
    "gray":    { XS:"43700823261341", S:"43700823392413", M:"43700823523485", L:"43700823654557", XL:"43700823785629", XXL:"43700823916701" },
    "grey":    { XS:"43700823261341", S:"43700823392413", M:"43700823523485", L:"43700823654557", XL:"43700823785629", XXL:"43700823916701" },
    "olive":   { XS:"43700823359645", S:"43700823490717", M:"43700823621789", L:"43700823752861", XL:"43700823883933", XXL:"43700824047773" },
    "skyblue": { XS:"43704960286877", S:"43704960319645", M:"43704960352413", L:"43704960385181", XL:"43704960417949", XXL:"43704960450717" },
    "sky blue":{ XS:"43704960286877", S:"43704960319645", M:"43704960352413", L:"43704960385181", XL:"43704960417949", XXL:"43704960450717" },
    "mauve":   { XS:"43700823326877", S:"43700823457949", M:"43700823589021", L:"43700823720093", XL:"43700823851165", XXL:"43700824015005" },
    "tan":     { XS:"45455711994013", S:"45455712059549", M:"45455712125085", L:"45455712190621", XL:"45455712256157", XXL:"45455712321693" }
  };

  /* Colour names get typed by hand in the theme editor and rarely match the
     product's option value character for character: "Light Blue" vs "Skyblue",
     "Peach" vs "Tan", "Grey" vs "Gray". Squash to letters only, then run a
     small alias table, so a mismatch cannot silently disable stock. */
  var COLOR_ALIAS = {
    lightblue: "skyblue", skyblue: "skyblue", blue: "skyblue",
    peach: "tan", tan: "tan", sand: "tan",
    grey: "gray", gray: "gray",
    mauve: "mauve", pink: "mauve",
    olive: "olive", green: "olive",
    navy: "navy", black: "black", white: "white"
  };

  function normColor(name) {
    var k = String(name || "").toLowerCase().replace(/[^a-z]/g, "");
    return COLOR_ALIAS[k] || k;
  }

  function variantFor(colorName, size) {
    var key = String(colorName || "").trim().toLowerCase();
    var row = FALLBACK_IDS[key] || FALLBACK_IDS[normColor(colorName)];
    return row ? row[String(size || "").toUpperCase()] : null;
  }

  function recommendSize(inches, pounds) {
    var h = Number(inches), w = Number(pounds);
    if (!h || !w) return "";
    if (h <= 66) return w <= 130 ? "XS" : w <= 145 ? "S" : w <= 189 ? "M" : w <= 215 ? "L" : w <= 240 ? "XL" : "XXL";
    if (h <= 69) return w <= 165 ? "S" : w <= 190 ? "M" : w <= 215 ? "L" : w <= 250 ? "XL" : "XXL";
    if (h <= 73) return w <= 175 ? "M" : w <= 220 ? "L" : w <= 250 ? "XL" : "XXL";
    if (h <= 76) return w <= 200 ? "L" : w <= 240 ? "XL" : "XXL";
    return w <= 235 ? "XL" : "XXL";
  }

  function embedURL(url) {
    var yt = url.match(/(?:youtu\.be\/|[?&]v=|embed\/|shorts\/)([\w-]{6,})/);
    if (yt) return "https://www.youtube.com/embed/" + yt[1] + "?autoplay=1&rel=0&modestbranding=1&playsinline=1";
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return "https://player.vimeo.com/video/" + vm[1] + "?autoplay=1";
    return url;
  }

  function revealImages(scope) {
    var imgs = scope.querySelectorAll(".r6-fade");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute("data-loaded")) continue;
      /* complete with no width means it already failed, before this script ran.
         Either way it must not sit there invisible. */
      if (img.complete) {
        img.setAttribute("data-loaded", "1");
      } else {
        img.addEventListener("load", function () {
          this.setAttribute("data-loaded", "1");
        }, { once: true });
        /* a failed image must not stay invisible */
        img.addEventListener("error", function () {
          this.setAttribute("data-loaded", "1");
        }, { once: true });
      }
    }
  }

  /* Once the page itself has loaded, quietly pull the rest of the photos into
     cache in the background — the other six colours, their thumbnails, the
     reason shots, the looks. Two at a time so a slow line is never flooded,
     and only after the hero and first colour are already on screen. By the
     time a visitor scrolls down or taps a swatch the image is usually there. */
  function warmImages(root) {
    var wanted = [];

    function want(url) {
      if (url && wanted.indexOf(url) === -1) wanted.push(url);
    }

    /* every colour's five photos, in the size the page will actually use */
    var tag = root.querySelector("[data-r6-colors]");
    if (tag) {
      try {
        var list = JSON.parse(tag.textContent) || [];
        for (var i = 0; i < list.length; i++) {
          var shots = list[i].imgs || [];
          for (var s = 0; s < shots.length; s++) want(shots[s]);
        }
      } catch (e) {}
    }

    /* anything still waiting to be lazy loaded further down the page */
    var lazy = root.querySelectorAll('img[loading="lazy"]');
    for (var l = 0; l < lazy.length; l++) {
      if (lazy[l].complete) continue;
      want(lazy[l].currentSrc || lazy[l].src);
    }

    var at = 0, live = 0, MAX = 2;

    function next() {
      if (at >= wanted.length) return;
      var url = wanted[at++];
      live++;
      var img = new Image();
      img.decoding = "async";
      if ("fetchPriority" in img) img.fetchPriority = "low";
      img.onload = img.onerror = function () {
        live--;
        next();
      };
      img.src = url;
      if (live < MAX) next();
    }

    next();
  }

  function scheduleWarm(root) {
    /* never compete with the visible part of the page */
    var start = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(function () { warmImages(root); }, { timeout: 3000 });
      else window.setTimeout(function () { warmImages(root); }, 1200);
    };
    if (document.readyState === "complete") start();
    else window.addEventListener("load", start, { once: true });
  }

  function init(root) {
    var id = attr(root, "data-section-id", "");
    var bar = document.getElementById("r6-bar-" + id);
    var finder = document.getElementById("r6-finder-" + id);
    var buyBlock = document.getElementById("r6-buy-" + id);

    /* If a theme ancestor has a transform or filter, position:fixed anchors to
       that ancestor instead of the viewport, which leaves a gap under the bar.
       Re-parenting to <body> guarantees it sits flush at the bottom. */
    if (bar && bar.parentNode !== document.body) document.body.appendChild(bar);
    if (finder && finder.parentNode !== document.body) document.body.appendChild(finder);

    var ACCENT = attr(root, "data-accent", "#0071e3");

    /* Colour data lives in a JSON script tag, so no attribute escaping can
       break it. If it ever fails to parse we carry on with an empty list —
       the click handlers must still bind or the whole page goes dead. */
    var COLORS = [];
    var dataTag = root.querySelector("[data-r6-colors]");
    if (dataTag) {
      try { COLORS = JSON.parse(dataTag.textContent) || []; }
      catch (e) {
        if (window.console && console.error) console.error("[co36-polo] colour data", e);
        COLORS = [];
      }
    }

    /* Sold out variant ids, printed by the section from live inventory. */
    var SOLD = {};
    var stockTag = root.querySelector("[data-r6-stock]");
    if (stockTag) {
      try {
        (JSON.parse(stockTag.textContent) || []).forEach(function (id) { SOLD[String(id)] = true; });
      } catch (e) {}
    }
    /* The same sold out list keyed on the product's own option values,
       "OLIVE|L", so stock works without a matching id table. */
    var SOLDPAIR = {};
    var pairTag = root.querySelector("[data-r6-stock-pairs]");
    if (pairTag) {
      try {
        (JSON.parse(pairTag.textContent) || []).forEach(function (k) {
          var half = String(k).split("|");
          var a = half[0] || "", b = half[1] || "";
          /* store both orderings, colour normalised, size as plain letters */
          SOLDPAIR[normColor(a) + "|" + b.replace(/[^A-Za-z0-9]/g, "").toUpperCase()] = true;
          SOLDPAIR[normColor(b) + "|" + a.replace(/[^A-Za-z0-9]/g, "").toUpperCase()] = true;
        });
      } catch (e) {}
    }

    /* Do we actually have inventory data to judge with? If not, nothing on the
       page may be shown as unavailable. */
    var hasStockData = false;
    for (var sk in SOLD) { if (Object.prototype.hasOwnProperty.call(SOLD, sk)) { hasStockData = true; break; } }
    for (var pk in SOLDPAIR) { if (Object.prototype.hasOwnProperty.call(SOLDPAIR, pk)) { hasStockData = true; break; } }

    /* fit notes:  "XS,S|description"  per line */
    var FIT = {};
    attr(root, "data-fit-notes", "").split("\n").forEach(function (line) {
      var half = line.split("|");
      if (half.length < 2) return;
      half[0].split(",").forEach(function (sz) {
        FIT[sz.trim().toUpperCase()] = half[1].trim();
      });
    });

    /* size chart:  "M,39-41,38-40"  per line */
    var CHART = [];
    attr(root, "data-measurements", "").split("\n").forEach(function (line) {
      var c = line.split(",");
      if (c.length >= 3) CHART.push({ size: c[0].trim(), chest: c[1].trim(), waist: c[2].trim() });
    });

    /* An exact match, then a loose one. Never fall back to COLORS[0]: doing so
       resolved an unknown colour to the FIRST colour's variant, which then
       collided with another row and merged three shirts into two. */
    function colorByName(name) {
      var want = String(name || "").trim().toLowerCase();
      for (var i = 0; i < COLORS.length; i++) if (COLORS[i].name === name) return COLORS[i];
      for (var j = 0; j < COLORS.length; j++) {
        if (String(COLORS[j].name || "").trim().toLowerCase() === want) return COLORS[j];
      }
      var wantN = normColor(name);
      for (var k = 0; k < COLORS.length; k++) {
        if (normColor(COLORS[k].name) === wantN) return COLORS[k];
      }
      return { name: name, imgs: [], variants: {} };
    }

    function variantId(colorName, size) {
      return (colorByName(colorName).variants || {})[size] || variantFor(colorName, size) || "";
    }

    /* Only strike something out on POSITIVE proof that it is sold out: we must
       know the variant id AND have seen it in the sold-out list. An unknown id
       means our data is incomplete, not that the shirt is gone — treating it as
       sold out is what struck out all six sizes and killed the page. */
    function inStock(colorName, size) {
      /* Name and size first: it comes straight off the product, so it is right
         even when the id table is stale or belongs to another product. Both
         orders are checked because the option order can be Size / Colour. */
      var c = normColor(colorName);
      var s = String(size || "").replace(/[^A-Za-z0-9]/g, "").toUpperCase();
      if (c && s && SOLDPAIR[c + "|" + s]) return false;
      var vid = variantId(colorName, size);
      if (!vid) return true;
      return !SOLD[String(vid)];
    }

    /* Sanity check the stock read. If nothing at all is buyable, the data is
       wrong rather than the shop being empty — mismatched variant ids or the
       wrong product handle. Discard it: a page with every size struck out
       sells nothing, and /cart/add.js will still refuse a real sold-out line. */
    function sanityCheckStock() {
      if (!COLORS.length || !SIZES.length) return;
      var anyBuyable = false;
      for (var ci = 0; ci < COLORS.length && !anyBuyable; ci++) {
        for (var si = 0; si < SIZES.length; si++) {
          if (inStock(COLORS[ci].name, SIZES[si])) { anyBuyable = true; break; }
        }
      }
      if (!anyBuyable) {
        SOLD = {};
        SOLDPAIR = {};
        if (window.console && console.warn) {
          console.warn("[co36-polo] stock data marked every variant sold out, so it was ignored. Check the Product handle setting and the Variant IDs in each Color block.");
        }
      }
    }

    /* a colour is dead only when every size is gone */
    function colorHasAnyStock(colorName) {
      for (var i = 0; i < SIZES.length; i++) {
        if (inStock(colorName, SIZES[i])) return true;
      }
      return false;
    }

    /* read the server rendered defaults so JS and HTML can never disagree */
    var rowEls = root.querySelectorAll("[data-row]");
    var picks = [];
    for (var i = 0; i < rowEls.length; i++) {
      var fallback = COLORS.length ? COLORS[Math.min(i, COLORS.length - 1)].name : "";
      picks.push(attr(rowEls[i], "data-chosen", fallback));
    }
    while (picks.length < 3) picks.push(picks[0] || (COLORS[0] && COLORS[0].name) || "");

    var SIZES = [];
    (function () {
      var btns = root.querySelectorAll("[data-size]");
      for (var i = 0; i < btns.length; i++) SIZES.push(btns[i].getAttribute("data-size"));
    })();
    sanityCheckStock();

    var state = {
      pack: "3pack",
      size: "",
      color: attr(root, "data-default-color", (COLORS[0] && COLORS[0].name) || ""),
      colors3: picks,
      gallery: picks[0],
      shot: 0,
      chartOpen: false
    };

    /* ---------- selection painting ---------- */

    function paintSwatches(scope, selected) {
      var list = scope.querySelectorAll("[data-color]");
      for (var i = 0; i < list.length; i++) {
        var on = list[i].getAttribute("data-color") === selected;
        list[i].setAttribute("aria-checked", on ? "true" : "false");
      }
    }

    function paintGallery() {
      /* every colour's gallery is already in the DOM; reveal the active one */
      var gals = root.querySelectorAll("[data-gal]");

      for (var i = 0; i < gals.length; i++) {
        var gal = gals[i];
        var isOn = gal.getAttribute("data-gal") === state.gallery;
        gal.hidden = !isOn;
        if (!isOn) continue;

        var thumbs = gal.querySelectorAll("[data-shot]");
        for (var n = 0; n < thumbs.length; n++) {
          var slot = Number(thumbs[n].getAttribute("data-shot"));
          thumbs[n].setAttribute("aria-checked", slot === state.shot ? "true" : "false");
        }

        var bigImg = gal.querySelector("[data-main] img");
        if (bigImg) {
          if (state.shot === 0) {
            bigImg.setAttribute("src", bigImg.getAttribute("data-original"));
            bigImg.removeAttribute("srcset");
          } else {
            var pick = gal.querySelector('[data-shot="' + state.shot + '"] img');
            if (pick) {
              /* thumbnails are served small; ask Shopify for a full size copy
                 of the same file rather than blowing one up */
              var big = pick.getAttribute("src").replace(/([?&]width=)\d+/, "$1" + 1100);
              bigImg.setAttribute("src", big);
              bigImg.removeAttribute("srcset");
            }
          }
        }
      }

      var label = root.querySelector("[data-shown]");
      if (label) label.textContent = state.gallery;
    }

    function paint() {
      var isPack = state.pack === "3pack";

      var packs = root.querySelectorAll("[data-pack]");
      for (var i = 0; i < packs.length; i++) {
        packs[i].setAttribute("aria-checked", packs[i].getAttribute("data-pack") === state.pack ? "true" : "false");
      }

      var pack3Wrap = root.querySelector("[data-pack3]");
      var singleWrap = root.querySelector("[data-single]");
      if (pack3Wrap) pack3Wrap.hidden = !isPack;
      if (singleWrap) singleWrap.hidden = isPack;

      for (var r = 0; r < rowEls.length; r++) {
        var name = state.colors3[r];
        rowEls[r].setAttribute("data-chosen", name);
        var rowLabel = rowEls[r].querySelector("[data-chosen-label]");
        if (rowLabel) rowLabel.textContent = name;
        paintSwatches(rowEls[r], name);
      }
      if (singleWrap) {
        var singleLabel = singleWrap.querySelector("[data-chosen-label]");
        if (singleLabel) singleLabel.textContent = state.color;
        paintSwatches(singleWrap, state.color);
      }

      /* SIZE FIRST. A size is only struck out when it is gone in every colour,
         so the size row never depends on which colours happen to be picked.
         Colours then react to the chosen size. Much less confusing on a bundle. */
      var sizes = root.querySelectorAll("[data-size]");
      var deadSizes = [];
      for (var s = 0; s < sizes.length; s++) {
        var sz = sizes[s].getAttribute("data-size");
        sizes[s].setAttribute("aria-checked", sz === state.size ? "true" : "false");

        var anywhere = !COLORS.length || !hasStockData;
        for (var ci = 0; ci < COLORS.length && !anywhere; ci++) {
          if (inStock(COLORS[ci].name, sz)) { anywhere = true; }
        }
        if (anywhere) {
          sizes[s].removeAttribute("data-soldout");
          sizes[s].removeAttribute("aria-disabled");
        } else {
          sizes[s].setAttribute("data-soldout", "");
          sizes[s].setAttribute("aria-disabled", "true");
          deadSizes.push(sz);
        }
      }
      if (state.size && deadSizes.indexOf(state.size) > -1) state.size = "";

      /* colours: only the ones you can actually get in that size */
      var allSw = root.querySelectorAll("[data-color]");
      for (var w = 0; w < allSw.length; w++) {
        var cname = allSw[w].getAttribute("data-color");
        var buyable = !hasStockData ? true
          : (state.size ? inStock(cname, state.size) : colorHasAnyStock(cname));
        var cell = allSw[w].parentElement;
        if (buyable) {
          allSw[w].removeAttribute("data-soldout");
          allSw[w].removeAttribute("aria-disabled");
          allSw[w].title = cname;
          if (cell) cell.removeAttribute("data-soldout");
        } else {
          allSw[w].setAttribute("data-soldout", "");
          allSw[w].setAttribute("aria-disabled", "true");
          allSw[w].title = cname + " is sold out" + (state.size ? " in " + state.size : "");
          if (cell) cell.setAttribute("data-soldout", "");
        }
      }

      /* if a picked colour just became unbuyable, move that row to one that works */
      if (state.size) {
        var swapped = false;
        for (var r2 = 0; r2 < state.colors3.length; r2++) {
          if (inStock(state.colors3[r2], state.size)) continue;
          for (var k = 0; k < COLORS.length; k++) {
            if (inStock(COLORS[k].name, state.size)) {
              state.colors3[r2] = COLORS[k].name;
              swapped = true;
              break;
            }
          }
        }
        if (!inStock(state.color, state.size)) {
          for (var k2 = 0; k2 < COLORS.length; k2++) {
            if (inStock(COLORS[k2].name, state.size)) { state.color = COLORS[k2].name; swapped = true; break; }
          }
        }
        if (swapped) {
          /* labels and swatch marks were painted from the old values */
          window.setTimeout(paint, 0);
        }
      }

      /* mark the selected cell so its name goes bold */
      for (var q = 0; q < allSw.length; q++) {
        var pc = allSw[q].parentElement;
        if (!pc) continue;
        if (allSw[q].getAttribute("aria-checked") === "true") pc.setAttribute("data-on", "");
        else pc.removeAttribute("data-on");
      }

      var note = root.querySelector("[data-soldnote]");
      if (note) {
        note.hidden = !deadSizes.length;
        note.textContent = deadSizes.length ? "Sold out: " + deadSizes.join(", ") : "";
      }

      var stepEl = root.querySelector("[data-colorstep]");
      if (stepEl) {
        stepEl.textContent = state.size
          ? "2. Choose 3 colors, available in " + state.size
          : "2. Choose 3 colors";
      }

      var cta = root.querySelector("[data-add]");
      if (cta) cta.textContent = !state.size
        ? attr(root, "data-cta-none", "Select your size")
        : isPack
          ? attr(root, "data-cta-pack", "Add the 3 Pack")
          : attr(root, "data-cta-single", "Add [color]").replace("[color]", state.color);

      var barTitle = bar && bar.querySelector("[data-bar-title]");
      var barSub = bar && bar.querySelector("[data-bar-sub]");
      if (barTitle) barTitle.textContent = isPack ? attr(root, "data-bar-pack", "") : attr(root, "data-bar-single", "");
      if (barSub) barSub.textContent = isPack ? attr(root, "data-bar-pack-sub", "") : attr(root, "data-bar-single-sub", "");

      paintGallery();
    }

    /* ---------- actions ---------- */

    function scrollToBuy() {
      if (!buyBlock) return;
      var top = buyBlock.getBoundingClientRect().top +
        (window.pageYOffset || document.documentElement.scrollTop) - 16;
      try { window.scrollTo({ top: top, behavior: "smooth" }); }
      catch (e) { window.scrollTo(0, top); }
    }

    function addToCart() {
      if (!state.size) { openFinder(); return; }

      var chosen = state.pack === "3pack" ? state.colors3 : [state.color];
      var tally = {};
      var order = [];
      var missing = [];
      chosen.forEach(function (name) {
        var vid = (colorByName(name).variants || {})[state.size] || variantFor(name, state.size);
        if (!vid) {
          if (missing.indexOf(name) < 0) missing.push(name);
          return;
        }
        vid = String(vid);
        if (!tally[vid]) order.push(vid);
        tally[vid] = (tally[vid] || 0) + 1;
      });
      var items = order.map(function (vid) {
        return { id: Number(vid), quantity: tally[vid] };
      });

      /* three chosen shirts must add up to three units, whatever the colours */
      var units = 0;
      for (var u = 0; u < items.length; u++) units += items[u].quantity;
      if (units !== chosen.length) {
        if (window.console && console.error) {
          console.error("[co36-polo] expected", chosen.length, "shirts, resolved", units,
            "— chosen:", chosen.slice(), "missing:", missing, "items:", items);
        }
      }

      if (!items.length) {
        window.alert(
          "No variant found for " + missing.join(", ") + " in size " + state.size +
          ".\n\nCheck that the Color block names match exactly: Black, White, Navy, Gray, " +
          "Olive, Skyblue, Mauve, Tan."
        );
        if (window.console && console.error) {
          console.error("[co36-polo] no variant IDs for:", missing, "size:", state.size);
        }
        return;
      }

      var cta = root.querySelector("[data-add]");
      cta.textContent = "Opening\u2026";
      cta.disabled = true;

      /* Shopify cart permalink: /cart/ID:qty,ID:qty?discount=CODE
         One navigation. No POST to /cart/add, no /discount/ hop, and it skips
         the theme's cart page entirely — that page is where the seconds go. */
      var parts = items.map(function (item) { return item.id + ":" + item.quantity; });
      var code = state.pack === "3pack" ? attr(root, "data-discount", "") : "";
      var url = "/cart/" + parts.join(",");
      if (code) url += "?discount=" + encodeURIComponent(code);

      window.location.href = url;

      /* Back button restores this page with the button mid-flight; reset it. */
      window.setTimeout(function () {
        cta.disabled = false;
        paint();
      }, 6000);
    }

    /* ---------- events ---------- */

    root.addEventListener("click", function (e) {
      var node = e.target;
      if (node && node.nodeType === 3) node = node.parentElement;
      if (!node || !node.closest) return;
      var t = node.closest(
        "[data-pack],[data-color],[data-size],[data-shot],[data-add],[data-to-buy],[data-open-finder],[data-play],[data-unmute]"
      );
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute("data-pack")) { state.pack = t.getAttribute("data-pack"); return paint(); }

      if (t.hasAttribute("data-color")) {
        window.setTimeout(function () { revealImages(root); }, 0);
        if (t.hasAttribute("data-soldout")) return;
        var name = t.getAttribute("data-color");
        var row = t.closest("[data-row]");
        if (row) {
          var idx = Number(row.getAttribute("data-row"));
          state.colors3[idx] = name;
        } else {
          state.color = name;
        }
        state.gallery = name;
        state.shot = 0;
        var pending = root.querySelectorAll(
          '[data-gal="' + name.replace(/"/g, '\\"') + '"] img[loading="lazy"]'
        );
        for (var pi = 0; pi < pending.length; pi++) pending[pi].setAttribute("loading", "eager");
        return paint();
      }

      if (t.hasAttribute("data-size")) {
        if (t.hasAttribute("data-soldout")) return;
        state.size = t.getAttribute("data-size");
        return paint();
      }
      if (t.hasAttribute("data-shot")) {
        if (t.hasAttribute("data-empty")) return;
        state.shot = Number(t.getAttribute("data-shot"));
        return paintGallery();
      }
      if (t.hasAttribute("data-add")) return addToCart();
      if (t.hasAttribute("data-to-buy")) return scrollToBuy();
      if (t.hasAttribute("data-open-finder")) return openFinder();

      if (t.hasAttribute("data-unmute")) {
        var vid = t.parentElement && t.parentElement.querySelector("video");
        if (!vid) return;
        var turningOn = vid.muted;
        if (turningOn) {
          /* only one video makes noise at a time */
          var all = root.querySelectorAll("video");
          for (var v = 0; v < all.length; v++) {
            if (all[v] === vid) continue;
            all[v].muted = true;
            var otherLabel = all[v].parentElement &&
              all[v].parentElement.querySelector("[data-unmute-label]");
            if (otherLabel) otherLabel.textContent = "Sound on";
          }
        }
        vid.muted = !turningOn;
        var lbl = t.querySelector("[data-unmute-label]");
        if (lbl) lbl.textContent = vid.muted ? "Sound on" : "Sound off";
        if (vid.paused) vid.play();
        return;
      }

      if (t.hasAttribute("data-play")) {
        var frame = t.closest("[data-video]");
        var url = frame && frame.getAttribute("data-video");
        if (url) {
          frame.innerHTML = '<iframe src="' + embedURL(url) +
            '" allow="autoplay; encrypted-media; fullscreen" allowfullscreen loading="lazy"></iframe>';
        }
      }
    });

    if (bar) {
      bar.addEventListener("click", function (e) {
        if (e.target.closest("[data-to-buy]")) scrollToBuy();
      });
    }

    /* ---------- size finder ---------- */

    function openFinder() { if (finder) finder.hidden = false; }
    function closeFinder() { if (finder) finder.hidden = true; }

    if (finder) {
      var heightSelect = finder.querySelector("[data-height]");
      for (var ft = 5; ft <= 6; ft++) {
        var last = ft === 6 ? 6 : 11;
        for (var inch = 0; inch <= last; inch++) {
          var opt = document.createElement("option");
          opt.value = String(ft * 12 + inch);
          opt.textContent = ft + "'" + inch + '"';
          heightSelect.appendChild(opt);
        }
      }

      function chartRows(recommended) {
        var html = '<div class="r6-ch r6-ch-h">Size</div>' +
          '<div class="r6-ch r6-ch-h r6-ch-r">Chest</div>' +
          '<div class="r6-ch r6-ch-h r6-ch-r">Waist</div>';
        CHART.forEach(function (m) {
          var on = m.size.toUpperCase() === String(recommended || "").toUpperCase();
          var cls = "r6-ch" + (on ? " r6-ch-on" : "");
          html += '<div class="' + cls + '">' + m.size + "</div>" +
            '<div class="' + cls + ' r6-ch-r">' + m.chest + "</div>" +
            '<div class="' + cls + ' r6-ch-r">' + m.waist + "</div>";
        });
        return html;
      }

      function refreshFinder() {
        var rec = recommendSize(heightSelect.value, finder.querySelector("[data-weight]").value);
        finder.querySelector("[data-result]").hidden = !rec;
        finder.querySelector("[data-apply]").hidden = !rec;
        finder.querySelector("[data-rec-size]").textContent = rec;
        finder.querySelector("[data-fit-note]").textContent = FIT[rec] || "";
        finder.querySelector("[data-chart]").innerHTML = chartRows(rec);
      }

      heightSelect.addEventListener("change", refreshFinder);
      finder.querySelector("[data-weight]").addEventListener("input", refreshFinder);
      finder.querySelector("[data-close]").addEventListener("click", closeFinder);
      finder.addEventListener("click", function (e) { if (e.target === finder) closeFinder(); });

      finder.querySelector("[data-toggle-chart]").addEventListener("click", function () {
        state.chartOpen = !state.chartOpen;
        finder.querySelector("[data-chart-wrap]").hidden = !state.chartOpen;
        this.textContent = state.chartOpen ? "Hide the size chart" : "See the size chart";
      });

      finder.querySelector("[data-apply]").addEventListener("click", function () {
        var rec = finder.querySelector("[data-rec-size]").textContent;
        if (!rec) return;
        state.size = rec;
        closeFinder();
        paint();
      });

      finder.querySelector("[data-chart]").innerHTML = chartRows("");
    }

    /* Autoplaying videos only run while they are on screen — six portrait
       clips playing at once would waste the visitor's data and battery. */
    function watchVideos() {
      var vids = root.querySelectorAll("video[autoplay]");
      if (!vids.length || !("IntersectionObserver" in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
            if (!v.muted) {
              v.muted = true;
              var lbl = v.parentElement && v.parentElement.querySelector("[data-unmute-label]");
              if (lbl) lbl.textContent = "Sound on";
            }
          }
        });
      }, { threshold: 0.35 });

      for (var i = 0; i < vids.length; i++) io.observe(vids[i]);
    }

    /* bfcache restores the page with the button mid-submit; reset it */
    window.addEventListener("pageshow", function (e) {
      if (!e.persisted) return;
      var backCta = root.querySelector("[data-add]");
      if (backCta) backCta.disabled = false;
      paint();
    });

    watchVideos();
    /* Hidden galleries hold lazy images, which browsers refuse to fetch while
       their container is hidden — clicking a swatch then showed grey boxes.
       Once the page has settled, quietly promote them all to eager so every
       color is already downloaded before it is asked for. */
    function warmGalleries() {
      var imgs = root.querySelectorAll('[data-gal] img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].setAttribute("loading", "eager");
        imgs[i].setAttribute("fetchpriority", "low");
      }
    }

    function whenIdle(fn) {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2500 });
      else window.setTimeout(fn, 1200);
    }

    if (document.readyState === "complete") whenIdle(warmGalleries);
    else window.addEventListener("load", function () { whenIdle(warmGalleries); }, { once: true });

    /* Claim the fade only now that revealImages is definitely available.
       The stylesheet keeps images visible until this class appears. */
    if (window.console && console.info) {
      var pairCount = 0;
      for (var dk in SOLDPAIR) { if (Object.prototype.hasOwnProperty.call(SOLDPAIR, dk)) pairCount++; }
      console.info("[co36-polo] colours:", COLORS.map(function (c) { return c.name; }).join(", "),
        "| sold out keys:", pairCount, "| stock data present:", hasStockData);
    }

    root.className = root.className ? root.className + " r6-js" : "r6-js";
    revealImages(root);
    scheduleWarm(root);
    paint();
  }

  function boot() {
    var all = document.querySelectorAll("[data-r6]");
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute("data-ready")) continue;
      all[i].setAttribute("data-ready", "1");
      try {
        init(all[i]);
      } catch (err) {
        if (window.console && console.error) {
          console.error("[co36-polo] setup failed:", (err && err.message) || err, (err && err.stack) || "");
        }
      }
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
